import React from 'react';
import { useSelector } from 'react-redux';

import DottedLoader from '../components/loaders/dotted-loader';
import { formatPrice } from '../utils/format-number';
import {
    formatPremiereDate,
    getPremiereDate,
    isPremiereLocked,
} from '../utils/premiere';

export function BestPriceDisplay() {
    const hasHotels = useSelector(state => !state.hotels.optional &&
        !state.hotels.without);
    const isLoadingPackages = useSelector(state => state.data.is_loading_packages);
    let bestPrice = useSelector(state => formatPrice(state.data.best_price));

    const hasLoadedPackages = useSelector(state => state.data.has_loaded_packages);
    const totalTicketsAvailable = useSelector(state => state.data.total_ticket_available);

    if (hasLoadedPackages && totalTicketsAvailable === 0) {
        return null;
    }

    if (isLoadingPackages) {
        return (
            <DottedLoader />
        );
    }

    if (!bestPrice) {
        bestPrice = '-';
    }

    let title = !hasHotels ? 'Biljetter från ' : 'Hotellpaket från ';
    let subtitle = bestPrice + ' kr';
    if (isPremiereLocked()) {
        title = !hasHotels ? 'Evenemang släpps ' : 'Hotellpaket släpps ';
        subtitle = formatPremiereDate(
            getPremiereDate(),
            'd MMMM',
        ).toLowerCase();
    }

    if (window.NOJESRESOR_PRODUCT.meta.event_is_canceled) {
        title = '';
        subtitle = 'Inställt';
    }

    if (window.NOJESRESOR_PRODUCT.meta.event_is_sold_out) {
        title = '';
        subtitle = 'Slutsålt';
    }

    return (
        <h2 className="single-product__header__summary-header__price">
            {title}
            <span className="text--highlight">
                {subtitle}
            </span>
        </h2>
    );
}
